export const goTop = ($element) => {
    $element.on('click', function (e) {
        e.preventDefault();
        let offsetTop = $($(this).attr('href')).offset().top;
        $('html').animate({scrollTop: offsetTop}, 1500);
    });
}